<div class="filtering-box">
    <nb-select size="small" status="primary" [(selected)]="filterMaterial"
        (selectedChange)="filterMaterialChange.next($event)">
        <nb-option value="">{{ 'common.all' | translate }}</nb-option>
        <nb-option [value]="-1">{{ 'device.status.pause-reason.no-material' | translate }}</nb-option>
        
        <nb-option-group *ngIf="materials.length" [title]="'device.files.material' | translate">
            <nb-option *ngFor="let material of materials; trackBy: materialTrackBy"
                [value]="material.name">
                {{ material.name }}
            </nb-option>
        </nb-option-group>
    </nb-select>
</div>